import axiosPost from "./axiosPost";

export const RNHDivisionDel = async (credentials, data) => {
    const body = {
        service: "RNHDivisionDel",
        params: {
            rnhDivisionId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
